var dom = require('./dom')
exports.DOMImplementation = dom.DOMImplementation
exports.XMLSerializer = dom.XMLSerializer
exports.DOMParser = require('./dom-parser').DOMParser



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@xmldom_xmldom@0.7.9@@xmldom/xmldom/lib/index.js
// module id = pOh4
// module chunks = 0